<template>
    <div>
        <div class="demo-upload-list"
            v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
                <img v-if="item.url.substring(item.url.length-3,item.url.length)!='mp4'" :src="item.url">
				<video v-if="item.url.substring(item.url.length-3,item.url.length)=='mp4'" :src="item.url"
					controls autoplay></video>
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline"
                        @click.native="handleView(item,item.url.substring(item.url.length-3,item.url.length)=='mp4')"></Icon>
                    <Icon v-show="mode !== 'detail'"
                        type="ios-trash-outline"
                        @click.native="handleRemove(item)"></Icon>
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress"
                    :percent="item.percentage"
                    hide-info></Progress>
            </template>
        </div>
        <Upload v-show="mode !== 'detail'"
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleUploadFileSuccess"
            :format="['jpg','jpeg','png','mp4']"
            :on-format-error="handleFormatError"
            :before-upload="beforeFileUpload"
            :data="uploadParams"
            multiple
            type="drag"
            :action="action"
            style="display: inline;width:58px;float:left;">
            <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="md-add"
                    size="20"></Icon>
            </div>
        </Upload>
        <Modal :title="imgName"
            v-model="visible">
            <img v-if="visible&&!isVideo" :src="imgUrl"
                style="width: 100%">
			<video style="width:488px;" v-if="isVideo" :src="imgUrl"
				controls autoplay></video>
        </Modal>
    </div>

</template>
<script>
import { UPLOAD_FILE_API, FILE_SERVER } from '@/api/modules/files';
//import { number } from 'echarts/lib/export';
import * as imageConversion from 'image-conversion';
import { qiniuToken } from '@/api/modules/product-management/product-management';
export default {
    name: 'FileUploadMulti',
    props: ['value', 'mode'],
    data() {
        return {
            action: "https://up-z2.qiniup.com/",
            defaultList: [],
            imgName: '',
            visible: false,
            uploadList: [],
            isVideo:false,
            uploadParams: {}
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue) {
                    let fileList = JSON.parse(newValue);
                    this.defaultList = fileList.map(item => {
                        return {
                            url: this.imageDomain + item.url,
                            name: item.name
                        };
                    });
                    this.$nextTick(() => {
                        this.uploadList = this.$refs.upload.fileList;
                    });
                }
            }
        }
    },
    methods: {
        getFileListJson() {
            let arr = [];
            this.uploadList = this.$refs.upload.fileList;
            this.uploadList.forEach(e => {
                arr.push({
                    name: e.name,
                    url: e.url.slice((this.imageDomain).length)
                });
            });
            return JSON.stringify(arr);
        },
        handleView(item, isVideo) {
            this.imgName = item.name;
            this.imgUrl = item.url;
            this.isVideo=isVideo;
            this.visible = true;
        },
        handleRemove(file) {
            const fileList = this.$refs.upload.fileList;
            let index = fileList.findIndex(e => {
                return e.url === file.url;
            });
            if (index !== -1) {
                this.$refs.upload.fileList.splice(index, 1);
                this.$nextTick(() => {
                    this.uploadList = this.$refs.upload.fileList;
                    this.$emit('input', this.getFileListJson());
                });
            }
        },
        handleSuccess(res, file) {
            file.url = FILE_SERVER + 'upload/' + res.data.fileList[0].fileUuid;
            file.name = res.data.fileList[0].fileName;
            this.$nextTick(() => {
                this.uploadList = this.$refs.upload.fileList;
                this.$emit('input', this.getFileListJson());
            });

        },
        handleFormatError(file) {
            this.$Modal.warning({
                title: '文件格式有误',
                content: file.name + ' 文件的格式有误，请选择 jpg,jpeg,png文件'
            });
        },
        handleMaxSize(file) {
            this.$Modal.warning({
                title: '文件大小超出限制',
                content: file.name + ' 太大, 先选择不超过 2M 的文件.'
            });
        },
        handleBeforeUpload(file) {
            const check = this.uploadList.length < 20;
            if (!check) {
                this.$Notice.warning({
                    title: '最多只能上传20张图片.'
                });
                return check;
            }
            return new Promise((resolve, reject) => {
			    //console.log('压缩前', file) // 压缩到500KB,这里的400就是要压缩的大小,可自定义
			    imageConversion.compressAccurately(file, 500).then(res => { // console.log(res)
			        res = new File([res], file.name, { type: res.type, lastModified: Date.now() });
			        //console.log('压缩后', res);
			        resolve(res);
			    });
            });
        },
        async beforeFileUpload(file) {
            const check = this.uploadList.length < 20;
            if (!check) {
                this.$Notice.warning({
                    title: '最多只能上传20张图片.'
                });
                return check;
            }
            let suffix = file.name.substring(file.name.lastIndexOf("."));
            let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;
            await qiniuToken({}).then(res => {
                this.uploadParams.token = res.data.token;
                // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                this.uploadParams.key = filename;
            });
        },
        handleUploadFileSuccess(request, file, list) {
            file.url = this.imageDomain + file.response.key;
            file.name = file.response.key;
            this.$nextTick(() => {
                this.uploadList = this.$refs.upload.fileList;
                this.$emit('input', this.getFileListJson());
            });
        }
		
    },
    mounted() {
        // this.uploadList = this.$refs.upload.fileList;
    }
};
</script>
<style>
.demo-upload-list {
    /* display: inline-block; */
    float: left;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    /* box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); */
    margin-right: 10px;
    margin-bottom: 2px;
}
.demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid lightgray;
    border-radius: 5px;
}
.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}
.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
/* .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}
.demo-upload-list img {
    width: 100%;
    height: 100%;
}
.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}
.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
} */
</style>
